import { useReducer, useEffect } from 'react'

function reducer(state, action) {
  switch (action.type) {
    case 'loading': return { data: state.data, loading: true, error: null }
    case 'success': return { data: action.data, loading: false, error: null }
    case 'error':   return { data: state.data, loading: false, error: action.error }
    default: return state
  }
}

export function useJsonFetch(url, { windowVar } = {}) {
  const [state, dispatch] = useReducer(reducer, { data: null, loading: false, error: null })

  useEffect(() => {
    if (windowVar && window[windowVar] !== undefined) {
      dispatch({ type: 'success', data: window[windowVar] })
      return
    }
    // Repli sur les fichiers mock (public/mock/) réservé au serveur de dev Vite (`import.meta.env.DEV`,
    // statiquement résolu à `false` dans un build — cette branche est alors éliminée du bundle). En
    // environnement cible, `windowVar` doit toujours être pré-posé par la JSP (voir CLAUDE.md,
    // « Intégration JSP ») ; s'il est absent ici, le bloc <script> de la JSP a probablement échoué à
    // s'exécuter (une erreur de syntaxe JS y interrompt tout le bloc, pas seulement l'instruction
    // fautive) — tenter /mock/*.json masquerait ce problème derrière un faux "HTTP 404".
    if (!import.meta.env.DEV) {
      if (windowVar) {
        console.error(`[useJsonFetch] window.${windowVar} est indéfini en environnement cible : le bloc <script> de la JSP n'a probablement pas pu s'exécuter (erreur de syntaxe JS ?) — vérifier les erreurs précédentes dans la console.`)
        dispatch({ type: 'error', error: `window.${windowVar} indéfini` })
      }
      return
    }
    if (!url) return
    dispatch({ type: 'loading' })
    fetch(url)
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status} ${r.statusText}`)
        return r.json()
      })
      .then(data => dispatch({ type: 'success', data }))
      .catch(err => {
        console.error(`[useJsonFetch] Échec du chargement de "${url}" :`, err)
        dispatch({ type: 'error', error: err.message })
      })
  }, [url, windowVar])

  return { data: state.data, loading: state.loading, error: state.error }
}
